import React, { useEffect, useState } from 'react';
import * as S from './styles';
import Modal from '../modal/Modal';
import { ClientProps } from '@/types';
import { SharedMarketOrder } from '@/components';
import SyncHeader from '@/components/modal-order-status/syncHeader';
import { OrderItemsProps } from '@/talons/orderStatusPage/useOrderStatusPage';
import useOrderStatusModal from '@/talons/orderStatusModal/useOrderStatusModal';
import { OrderStatusHeader, OrderStatusCard, CartOrderStatusCard, UpdateOrderStatus } from '@/components';
import { isOrderSyncedInStore } from '@/shared/ordersStore';

interface ModalProps {
  order: OrderItemsProps;
  isOpen: boolean;
  client: ClientProps;
  closeModal: (status: string) => void;
  clientRefNumber: string;
  clientName: string;
  clientCnpj: string;
  clientUnilever: boolean;
}

const OrderStatusModal = ({
  order,
  clientName,
  clientRefNumber,
  clientCnpj,
  client,
  isOpen = true,
  closeModal,
  clientUnilever,
}: ModalProps) => {
  const { handleReprocessOrder, loading } = useOrderStatusModal({
    order,
    companyData: {
      clientName,
      clientRefNumber,
      clientCnpj,
      clientUnilever,
    },
    closeModal: () => closeModal(order?.orderNumber),
  });

  const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    if (!order?.orderNumber) {
      setIsBlocked(false);
      return;
    }
    let cancelled = false;
    void isOrderSyncedInStore(order.orderNumber).then((synced) => {
      if (!cancelled) setIsBlocked(synced);
    });
    return () => {
      cancelled = true;
    };
  }, [order?.orderNumber]);

  return (
    <Modal
      isOpen={isOpen}
      isScrollable={true}
      direction={'right'}
      id={`modal-order-status-${order?.orderNumber}`}
      closeModal={() => closeModal(order?.orderNumber)}
    >
      {isOpen && (
        <S.Container>
          <S.Header>
            <S.Title>Ações pendentes neste pedido</S.Title>
          </S.Header>

          {/* <S.Divider /> */}

          <S.Body>
            <S.Content>
              {order?.status === 'indisponivel' && <SyncHeader syncOrder={handleReprocessOrder} />}

              <SharedMarketOrder client={client} order={order} />

              <S.Card>
                <S.InnerContainer>
                  <OrderStatusHeader client={client} clientName={clientName} clientRefNumber={clientRefNumber} />
                </S.InnerContainer>

                <OrderStatusCard isLast={true} order={order} status={order?.status} showMagentoNumber={true} />
              </S.Card>
            </S.Content>

            {order?.actionsPending?.length && (
              <React.Fragment>
                <S.Subtitle>
                  {order?.status !== 'reprocessar' && order?.status !== 'rejeitado' ? 'Produtos ' : 'Ações pendentes '}{' '}
                  {`(${order?.actionsPending?.length})`}
                </S.Subtitle>

                {order?.actionsPending?.map((item, index) => (
                  <CartOrderStatusCard item={item} isFirst={index === 0} key={`actions-pending-modal-card-${index}`} />
                ))}

                <UpdateOrderStatus
                  isLoading={loading}
                  grandTotal={order?.total}
                  quantity={Number(order?.quantity)}
                  canProcessOrder={!!order?.isLocal && !isBlocked}
                  processOrder={handleReprocessOrder}
                  paymentCondition={Number(order?.paymentTerms)}
                />
              </React.Fragment>
            )}
          </S.Body>
        </S.Container>
      )}
    </Modal>
  );
};

export default OrderStatusModal;
